import EllipsisText from 'components/EllipsisText';

const createRenderCell =
  ({ key }) =>
  (item) =>
    <EllipsisText fontType="Body">{item[key]}</EllipsisText>;

export default createRenderCell;
